








"use strict";

const httpUtil = require("common-util/browser/http-util.js");
const XuxTableSupport = require("common-util/browser/xux-table-support.js");
const {WebStorageManager} = require("common-util/browser/webstorage-util.js");
const storage = new WebStorageManager();
const app = require("./app-common.js");
const order = require("./order.js");
const Util = require("./util");
const util = new Util();
const moment = require("moment");

app.init(true);

$(() => {
    $.validator.addMethod("settingNameUpdateRequired", () => {
        let paramValue = $("#update-modalWindow").find("input[name='setting-name']").val();
        return !util.isParamEmpty(paramValue);
    }, "");
});
app.ready(() => {
    util.afterLoginApply(app, order, "settings");
    util.logOutHeader(app);
    util.initSupportMenu(app);
    util.initLogoutMenu(app);

    let menuInstance = $("#utilmenu").xuxContextMenu({
        select(event, ui) {
            let selectType = ui.item.children("a").attr("href");
            if (selectType === "#install") {
                install(ui.context);
            }
            if (selectType === "#delete") {
                deleteSetting(ui.context);
            }
        },
        beforeOpen() {
            setElemDisable(menuInstance.children(), storage.getItem("orderFinished") === "true");
            window.document.activeElement.blur();
            return true;
        }
    });

    
    const setElemDisable = (jQueryElem, isDisable) => {
        if (isDisable) {
            jQueryElem.addClass("ui-state-disabled");
        } else {
            jQueryElem.removeClass("ui-state-disabled");
        }
    };

    
    let settingXuxTable = new XuxTableSupport({
        elem: $("#decoratedTable_setting"),
        l10n: app.l10n,
        columns: {
            settingId: {
                _hidden: true
            },
            origin: {
                _hidden: true
            },
            formatVersion: {
                _hidden: true
            },
            deviceVersion: {
                _hidden: true
            },
            countryCode: {
                _hidden: true
            },
            settingName: {
                contentEllipsis: true,
                _localizationLabel: "settings.label.name",
                defaultSortOrder: "asc",
                render(td, item) {
                    td.append(util.text(item.get("settingName")));
                    td.data("settingId", item.get("settingId"));
                }
            },
            createdAt: {
                _localizationLabel: "order.label.createDate",
                _defaultSort: true,
                contentEllipsis: true,
                defaultSortOrder: "desc",
                _sortByBeforeFormat: true,
                _formatter(value) {
                    return $.xux.formatDateTime(util.getDate(value), {seconds: true});
                }
            },
            settingComment: {
                _localizationLabel: "settings.label.memo",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            originName: {
                contentEllipsis: true,
                _localizationLabel: "settings.label.from",
                defaultSortOrder: "asc",
                _formatter(value, item) {
                    return item.get("origin") === "tool" ? window.localizedTextMessages.api.tool : value;
                }
            },
            action: {
                _localizationLabel: "com.label.blank",
                render(td, item) {
                    $("<span />").prop("class", "xux-icon xux-icon-ellipsisvert").xuxContextMenuTrigger({
                        menu: menuInstance,
                        context: item
                    }).appendTo(td);
                },
                _noQuery: true,
                width: "fitContent"
            }
        },
        supportOptions: {
            enableBrowserfilter: true,
            cachePagingMethod: "noPaging",
            fetch() {
                let url = settingXuxTable.createQueryUrl(
                    httpUtil.getApiUrl("/p2p/settings") + "?timestamp=" + Date.now());
                return app.ajaxAuth({
                    url,
                    type: "get",
                    contentType: "application/json",
                    data: {
                        orderId: storage.getItem("orderId")
                    }
                });
            }
        },
        xuxOptions: {
            selectionControl: "checkbox",
            selectionRemains: true,
            pageNavigation: "none",
            selectionUnit: "row",
            itemId: "settingId",
            autoLoad: false,
            columnResizable: true,
            sortOptions: {
                column: 2,
                order: "desc"
            },
            select: checkSettingSelection,
            unselect: checkSettingSelection,
            afterRender: checkSettingSelectionANdOrderFinished
        }});
    settingXuxTable.init();

    function checkSettingSelection() {
        let selectionNum = settingXuxTable.invoke("selectedItemIds").length;
        $("#setting-delete-many").xuxButton(selectionNum > 0 ? "enable" : "disable");
    }

    function checkSettingSelectionANdOrderFinished() {
        const orderFinished = storage.getItem("orderFinished") === "true";
        if (orderFinished) {
            settingXuxTable.invoke("resetAllSelections");
        }
        let selectionNum = settingXuxTable.invoke("selectedItemIds").length;
        $("#setting-delete-many").xuxButton((orderFinished || selectionNum === 0) ? "disable" : "enable");
        const notLastTds = $("#decoratedTable_setting table tbody tr td:not(:last-child)");
        const onlyMiddleTds = $("#decoratedTable_setting table tbody tr td:not(:first-child):not(:last-child)");
        const lastTd = $("#decoratedTable_setting table tbody tr td:last-child");
        setElemDisable(notLastTds, orderFinished);
        if (orderFinished) {
            onlyMiddleTds.addClass("cancel-disable-opacity");
            lastTd.addClass("disable-context-menu");
        } else {
            onlyMiddleTds.removeClass("cancel-disable-opacity");
            lastTd.removeClass("disable-context-menu");
        }
        setElemDisable($(".xux-selectAllButton"), orderFinished);
    }

    
    let deviceXuxTable = new XuxTableSupport({
        elem: $("#device-select"),
        l10n: app.l10n,
        columns: {
            deviceId: {
                _hidden: true,
            },
            deviceName: {
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _localizationLabel: "device.label.name"
            },
            displayName: {
                _localizationLabel: "device.label.modelSerial",
                _defaultSort: true,
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            pollable: {
                _hidden: true
            },
            polling: {
                _hidden: true
            },
            settingFormatVersion: {
                _hidden: true
            },
            settingDeviceVersion: {
                _hidden: true
            },
            countryCode: {
                _hidden: true
            }
        },
        supportOptions: {
            enableBrowserfilter: true,
            cachePagingMethod: "noPaging",
            dataFilter(item) {
                let {
                    formatVersion,
                    deviceVersion,
                    countryCode
                } = installModalWindow.xuxModalWindow("option", "targetSetting");
                return item[3] && item[4]
                    && util.checkFormatVersion(item[5], formatVersion)
                    && util.checkDeviceVersion(item[6], deviceVersion)
                    && util.checkCountryCode(item[7], countryCode);
            },
            fetch() {
                let url = deviceXuxTable.createQueryUrl(
                    httpUtil.getApiUrl("/p2p/devices") + "?timestamp=" + Date.now());
                return app.ajaxAuth({
                    url,
                    type: "get",
                    contentType: "application/json",
                    data: {
                        orderId: storage.getItem("orderId")
                    }
                });
            }
        },
        xuxOptions: {
            selectionUnit: "row",
            select: checkDeviceSelection,
            unselect: checkDeviceSelection,
            afterRender: checkDeviceSelection,
            columnResizable: true,
            selectionControl: "checkbox",
            selectionRemains: true,
            pageNavigation: "none",
            itemId: "deviceId",
            autoLoad: false,
            sortOptions: {
                column: 2,
                order: "asc"
            }
        }});
    deviceXuxTable.init();

    function checkDeviceSelection() {
        let selectionNum = deviceXuxTable.invoke("selectedItemIds").length;
        $("#device-select-yes").xuxButton(selectionNum > 0 ? "enable" : "disable");
    }
    
    let installModalWindow = util.patchModalWindow("#device-select-modalWindow");
    installModalWindow.xuxModalWindow({
        leadingMargin: false,
        type: "settings",
        width: "normal",
        height: "fit",
        open() {
            $("#device-select-yes").xuxButton("disable");

            deviceXuxTable.invoke("reload");

            $("#device-select-cancel").unbind("click").click(() => {
                installModalWindow.xuxModalWindow("close");
            });

            $("#device-select-yes").unbind("click").click(() => {
                let deviceIds = deviceXuxTable.invoke("selectedItemIds");
                let deviceId = deviceIds[0];
                backupSendModalWindow.xuxModalWindow("option", "targetDeviceIds", deviceIds);
                backupSendModalWindow.xuxModalWindow("option", "targetDeviceId", deviceId);
                backupSendModalWindow.xuxModalWindow("open");
            });
        },
        close() {
            deviceXuxTable.invoke("clearSearch");
            deviceXuxTable.invoke("resetAllSelections");
        }
    });
    
    let backupSendModalWindow = util.patchModalWindow("#backup-send-modalWindow");
    backupSendModalWindow.find("form").xuxValidate();
    if (!backupSendModalWindow.parent().hasClass("xux-modalWindow")) {
        backupSendModalWindow.xuxModalWindow({
            leadingMargin: false,
            type: "settings",
            width: "wide",
            height: "auto",
            open() {
                backupSendModalWindow.find("form")[0].reset();

                if ($("#hour").children("option").length === 0) {
                    util.setTimeDropdown($("#hour"), $("#minute"));
                }
                let select = backupSendModalWindow.find("#time-setting select");
                $("#date").xuxDateField("disable");
                select.attr("disabled", "disabled").xuxDropdown("refresh");
                $("#backup-device-select-cancel").unbind("click").click(() => {
                    backupSendModalWindow.xuxModalWindow("close");
                });
                backupSendModalWindow.find("input[name='time-setting-box']").change(() => {
                    if ($("#time-setting-check input[type='radio']").eq(1).is(":checked")) {
                        $("#date").xuxDateField("enable");
                        select.removeAttr("disabled").xuxDropdown("refresh");
                        util.limitAssignationTime();
                    } else {
                        $("#date").xuxDateField("disable");
                        select.attr("disabled", true).xuxDropdown("refresh");
                    }
                });
                $("#backup-device-select-yes").unbind("click").click(() => {
                    if (!backupSendModalWindow.find("form").xuxValidate("valid")) {
                        return;
                    }

                    let scheduledDatetime = "";
                    if ($("#time-setting-check input[type='radio']").eq(1).is(":checked")) {
                        let assignationTime = moment($("#date").val() + " " + $("#hour").val() + ":" + $("#minute").val(), "YYYY-MM-DD HH:mm");
                        if (!util.checkDate(assignationTime)) {
                            return;
                        }
                        scheduledDatetime = assignationTime.format("YYYY-MM-DDTHH:mm:ssZ");
                    }

                    let categoryObj = $("#category-setting-check input[name='category-setting-box']").filter(":checked").attr("id");

                    let deviceIds = backupSendModalWindow.xuxModalWindow("option", "targetDeviceIds");
                    let {settingId} = installModalWindow.xuxModalWindow("option", "targetSetting");
                    
                    util.message({
                        flag: "2",
                        title: window.localizedTextMessages.instruction.title.send,
                        message: window.localizedTextMessages.instruction.warn.send,
                        yesBtnMsg: window.localizedTextMessages.com.btn.ok,
                        callbackObj: {
                            ok() {
                                let needOwnAlert = deviceIds.length > 1;
                                let operation = {
                                    type: "restore",
                                    settingId,
                                    scheduledDatetime
                                };
                                if (categoryObj === "category-setting-address") {
                                    operation.categories = ["AddressBook"];
                                }
                                return new Promise((resolve, reject) => {
                                    deviceIds.forEach(deviceId => {
                                        app.ajaxAuth({
                                            url: httpUtil.getApiUrl("/p2p/jobs?orderId=" + storage.getItem("orderId")),
                                            type: "post",
                                            contentType: "application/json",
                                            asynAjax: needOwnAlert,
                                            data: JSON.stringify({
                                                deviceId,
                                                operation
                                            })
                                        }).then(resolve).catch(err => {
                                            if (needOwnAlert) {
                                                needOwnAlert = false;
                                                util.message({
                                                    title: window.localizedTextMessages
                                                        .errorMsg.multipleInstructionError,
                                                    yesBtnMsg: window.localizedTextMessages
                                                        .com.btn.close,
                                                    type: "fault"
                                                });
                                            }
                                            reject(err);
                                        });
                                    });
                                });
                            }
                        }
                    }).then(isOk => {
                        if (isOk) {
                            backupSendModalWindow.xuxModalWindow("close");
                            installModalWindow.xuxModalWindow("close");
                            settingXuxTable.invoke("reload");
                        }
                    }).catch($.noop);
                });
            }
        });
    }

    function install(context) {
        let targetSetting = {
            settingId: context.get("settingId"),
            formatVersion: context.get("formatVersion"),
            deviceVersion: context.get("deviceVersion"),
            countryCode: context._data.getOriginal("countryCode")
        };
        installModalWindow.xuxModalWindow("option", "targetSetting", targetSetting);
        installModalWindow.xuxModalWindow("open");
    }

    function deleteSetting(context) {
        let title = window.localizedTextMessages.settings.title.deleteSettings;
        let message = window.localizedTextMessages.settings.warn.deleteSettings;
        util.messageAlertTable({
            title,
            message,
            yesBtnMsg: window.localizedTextMessages.com.btn.delete,
            data: [{settingName: context.get("settingName")}],
            thead: ["settings.label.name"],
            tbody(data) {
                let tr = "<tr><td><div>" + util.text(data.settingName) + "</div></td></tr>";
                return tr;
            },
            yes() {
                return app.ajaxAuth({
                    url: httpUtil.getApiUrl("/p2p/settings/" + context.get("settingId") + "?orderId=" + storage.getItem("orderId")),
                    type: "delete",
                    contentType: "application/json"
                }).then(() => {
                    settingXuxTable.invoke("reload");
                });
            }
        });
    }

    function deleteSettings(ids, nameArr) {
        let title = window.localizedTextMessages.settings.title.deleteSettings;
        let message = window.localizedTextMessages.settings.warn.deleteSettings;
        util.messageAlertTable({
            title,
            message,
            data: nameArr,
            thead: ["settings.label.name"],
            yesBtnMsg: window.localizedTextMessages.com.btn.delete,
            tbody(data) {
                let tr = "<tr><td><div>" + util.text(data) + "</div></td></tr>";
                return tr;
            },
            yes() {
                return app.ajaxAuth({
                    url: httpUtil.getApiUrl("/p2p/settings/" + ids + "?orderId=" + storage.getItem("orderId")),
                    type: "delete",
                    contentType: "application/json",
                }).then(() => {
                    setTimeout(() => {
                        settingXuxTable.invoke("resetAllSelections");
                        settingXuxTable.invoke("reload");
                    }, 500);
                    $("#setting-delete-many").xuxButton("disable");
                });
            }
        });
    }

    $("#setting-delete-many").click(() => {
        let selectedIds = [];
        let selectedNames = [];

        settingXuxTable.invoke("selectedItems")
            .forEach(item => {
                selectedIds.push(item._data[item._fieldIndexes.settingId]);
                selectedNames.push(item._data[item._fieldIndexes.settingName]);
            });

        deleteSettings(selectedIds.join(","), selectedNames);
    });

    $("#orderid-update").click(() => {
        order.openOrderList(app);
    });

    if (!app.session.tenant.isFXTenant || storage.getItem("orderId")) {
        settingXuxTable.invoke("reload");
    }

    $("#body").xuxPage({
        width: "full",
        loginout: true,
        itemStates: ["selected", "", "", ""]
    });

    $("select").xuxDropdown({width: "narrowest"});
    $(".orderIdDiv").xuxApplyBoxAndLayout({
        labelLayout: "leading",
        contentEllipsis: true
    });
    if (!app.session.tenant.isFXTenant) {
        $(".orderIdDiv").xuxApplyBoxAndLayout().hide();
    }

    $("#backup-send-modalWindow").find("section").xuxApplyBoxAndLayout({
        labelLayout: "leading",
        itemLayout: "vertical",
        getBoxOptions(options) {
            if ($(this).is("#time-setting")) {
                return $.extend({}, options, {
                    itemLayout: "horizontal"
                });
            }
            return options;
        }
    });
    $("#device-select-modalWindow input[type='checkbox']").xuxCheckbox({labelLayout: "leading"});
    $("#select-all").change(() => {
        let checkbox = $("#backup-send-modalWindow input[type='checkbox']");
        if ($("#select-all").is(":checked")) {
            checkbox.prop("checked", true).xuxCheckbox("refresh");
        } else {
            checkbox.prop("checked", false).xuxCheckbox("refresh");
        }
    });

    $("header").xuxHeader("utilityLinks")
        .xuxUtilityLinks("option", "user", app.session.userName);
    $("a.date-select").xuxInfotip();
    $("#setting-delete-many").xuxButton("disable");
});
